var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _polygon, _rect4, _rect5, _polygon2, _rect6, _polygon3, _rect7, _rect8, _polygon4, _rect9, _polygon5, _polygon6, _rect10, _rect11, _rect12, _polygon7, _rect13, _rect14, _rect15, _rect16, _polygon8, _rect17, _rect18, _rect19, _polygon9, _rect20, _polygon10, _polygon11, _rect21, _rect22, _polygon12, _rect23, _rect24, _polygon13, _polygon14, _polygon15, _polygon16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCodeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "40-Qr code",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.79,91H9V64.92a2,2,0,0,0-4,0V93a2,2,0,0,0,2,2H34.79a2,2,0,0,0,0-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93,62.92a2,2,0,0,0-2,2V91H64.83a2,2,0,1,0,0,4H93a2,2,0,0,0,2-2V64.92A2,2,0,0,0,93,62.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93,5H65.06a2,2,0,0,0,0,4H91V34.66a2,2,0,0,0,4,0V7A2,2,0,0,0,93,5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7,37a2,2,0,0,0,2-2V9H34.91a2,2,0,0,0,0-4H7A2,2,0,0,0,5,7V35A2,2,0,0,0,7,37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19,20V36a2,2,0,0,0,2,2H37a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H21A2,2,0,0,0,19,20Zm4,2H35V34H23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63,38H79a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H63a2,2,0,0,0-2,2V36A2,2,0,0,0,63,38Zm2-16H77V34H65Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37,62H21a2,2,0,0,0-2,2V80a2,2,0,0,0,2,2H37a2,2,0,0,0,2-2V64A2,2,0,0,0,37,62ZM35,78H23V66H35Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 24,
    width: 8,
    height: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 68,
    width: 8,
    height: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 24,
    width: 8,
    height: 8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50 34 46 34 46 30 42 30 42 34 42 38 46 38 50 38 54 38 54 34 50 34"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 42,
    width: 4,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 46,
    width: 4,
    height: 4
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "46 42 42 42 42 46 46 46 50 46 50 42 46 42"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 46,
    width: 4,
    height: 4
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "34 54 34 58 38 58 38 54 38 50 34 50 34 54"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 50,
    width: 4,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 54,
    width: 4,
    height: 4
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "18 54 18 58 22 58 26 58 26 54 22 54 18 54"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 42,
    width: 4,
    height: 4
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "74 78 74 82 78 82 82 82 82 78 78 78 78 74 74 74 74 78"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "62 46 62 42 58 42 58 38 54 38 54 42 54 46 58 46 62 46"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 62,
    width: 4,
    height: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 66,
    width: 4,
    height: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 70,
    width: 4,
    height: 4
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "50 58 46 58 46 62 42 62 42 66 46 66 50 66 50 62 50 58"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 54,
    width: 4,
    height: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 46,
    width: 4,
    height: 4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 50,
    width: 4,
    height: 4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 54,
    width: 4,
    height: 4
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "54 34 58 34 58 30 58 26 54 26 54 30 54 34"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 26,
    width: 4,
    height: 4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 78,
    width: 4,
    height: 4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 74,
    width: 4,
    height: 4
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "54 22 54 18 50 18 46 18 46 22 50 22 50 26 54 26 54 22"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 58,
    width: 4,
    height: 4
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "62 70 58 70 58 74 54 74 50 74 50 78 54 78 54 82 58 82 58 78 62 78 62 74 62 70"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "70 70 66 70 66 74 66 78 70 78 70 74 74 74 74 70 70 70"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 54,
    width: 4,
    height: 4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 50,
    width: 4,
    height: 4
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "70 50 70 46 70 42 66 42 66 46 66 50 66 54 70 54 70 50"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 4,
    height: 4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 78,
    width: 4,
    height: 4
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "78 74 82 74 82 70 82 66 78 66 78 70 78 74"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "30 46 30 42 26 42 22 42 22 46 26 46 26 50 26 54 30 54 30 50 34 50 34 46 30 46"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "66 58 66 62 70 62 70 66 74 66 78 66 78 62 74 62 74 58 74 54 70 54 70 58 66 58"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "66 62 62 62 62 66 62 70 66 70 66 66 66 62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeWhite);
export default __webpack_public_path__ + "static/media/qrCode-white.8be3331eca00f576132c250bdfed0b10.svg";
export { ForwardRef as ReactComponent };